import moment from 'moment-timezone';

const UserContex = () => {
  let _timeZone = '';
  let _dateFormat: any = '';
  let _baseUrl: any = '';
  let _skinName: any = '';
  let otherPrivilegesTable: any = '';
  let otherPrivilegesAccount: any = '';
  let dataScoutPrivilege: any = '';

  const getTimeZoneName = () => {
    return window.localStorage.getItem('_timeZoneName') ?? '';
  };

  const getDateFormat = () => {
    return window.localStorage.getItem('_dateFormat') ?? _dateFormat;
  };

  return {
    setTimeZone: (timeZone: string) => {
      _timeZone = timeZone;
      window.localStorage.setItem('_timeZone', timeZone);
    },

    getTimeZone: () => {
      return window.localStorage.getItem('_timeZone') !== null ? window.localStorage.getItem('_timeZone') : _timeZone;
    },

    getTimeZoneName,

    setTimeZoneName: (timeZoneName: string) => {
      return window.localStorage.setItem('_timeZoneName', timeZoneName);
    },

    setDateFormat: (dateformat: string) => {
      _dateFormat = dateformat;
      window.localStorage.setItem('_dateFormat', dateformat);
    },

    getDateFormat,

    reformatUTCDate: (date?: string | null, format?: string): string | null => {
      if (!date) {
        return null;
      }
      return moment
        .utc(date)
        .tz(getTimeZoneName())
        .format(format ?? getDateFormat());
    },

    reformatPDTDate: (date?: string | null, format?: string): string | null => {
      if (!date) {
        return null;
      }
      return moment
        .tz(date, 'America/Los_Angeles')
        .tz(getTimeZoneName())
        .format(format ?? getDateFormat());
    },

    setBaseUrl: (baseUrl: string) => {
      _baseUrl = baseUrl;
      window.localStorage.setItem('_baseUrl', baseUrl);
    },

    getBaseUrl: () => {
      return window.localStorage.getItem('_baseUrl') !== undefined ? window.localStorage.getItem('_baseUrl') : _baseUrl;
    },

    getSkinName: () => {
      return window.localStorage.getItem('_SKIN') !== undefined ? window.localStorage.getItem('_SKIN') : _skinName;
    },

    setSkinName: (skinName: string) => {
      _skinName = skinName;
    },

    setOtherPrivilegesTable: (otherPrivilegesTable: any) => {
      otherPrivilegesTable = otherPrivilegesTable;
      window.localStorage.setItem('otherprivilegesTable', otherPrivilegesTable);
    },

    getOtherPrivilegesTable: () => {
      return window.localStorage.getItem('otherPrivilegesTable') !== undefined
        ? window.localStorage.getItem('otherPrivilegesTable')
        : otherPrivilegesTable;
    },

    setOtherPrivilegesAccount: (otherPrivilegesAccount: any) => {
      otherPrivilegesAccount = otherPrivilegesAccount;
      window.localStorage.setItem('otherPrivilegesAccount', otherPrivilegesAccount);
    },

    getOtherPrivilegesAccount: () => {
      return window.localStorage.getItem('otherPrivilegesAccount') !== undefined
        ? window.localStorage.getItem('otherPrivilegesAccount')
        : otherPrivilegesAccount;
    },

    setdataScoutPrivilege: (dataScoutPrivilege: any) => {
      dataScoutPrivilege = dataScoutPrivilege;
      window.localStorage.setItem('dataScoutPrivilege', dataScoutPrivilege);
    },

    getdataScoutPrivilege: () => {
      return window.localStorage.getItem('dataScoutPrivilege') !== undefined
        ? window.localStorage.getItem('dataScoutPrivilege')
        : dataScoutPrivilege;
    },
  };
};

export default UserContex();
